import { data } from 'react-router-dom';
import { get, post, put, del } from './api';

// Create a new category
export const createCategory = (data) => {
  return post('/categories', data);
};


export const getAllCategorys = (
  page = 1,
  limit = 10,
  search = '',
  sortField = 'id',       // default sorting field
  sortOrder = 'desc'      // default sorting order
) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (search) params.append('name', search);
  if (sortField) params.append('sort_field', sortField);
  if (sortOrder) params.append('sort_order', sortOrder);

  return get(`/categories?${params.toString()}`);
};


// Get all categories with pagination
export const getAllCategoryLists = () => {
  return get('/categories/list');
};


// Get a category by ID
export const getCategoryById = (id) => {
  return get(`/categories/${id}`);
};

// Update a category
export const updateCategory = (id, data) => {
  return put(`/categories/${id}`, data);
};

// Delete a category (soft delete if your backend supports it)
export const deleteCategory = (id) => {
  return del(`/categories/${id}`);
};


//subcategories

export const createSubCategory = (data) =>{
  return post ('/subcategories', data);
}

export const getAllSubCategorys = (
  page = 1,
  limit = 10,
  search = '',
  sortField = 'id',       // default sorting field
  sortOrder = 'desc'      // default sorting order
) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (search) params.append('name', search);
  if (sortField) params.append('sort_field', sortField);
  if (sortOrder) params.append('sort_order', sortOrder);

  return get(`/subcategories?${params.toString()}`);
};


// Get all subcategories with pagination
export const getAllSubCategory = () => {
  return get('/subcategories/all');
};


// Get a subcategories by ID
export const getSubCategoryById = (id) => {
  return get(`/subcategories/${id}`);
};

// Update a subcategories
export const updateSubCategory = (id, data) => {
  return put(`/subcategories/${id}`, data);
};

// Delete a subcategories (soft delete if your backend supports it)
export const deleteSubCategory = (id) => {
  return del(`/subcategories/${id}`);
};
